import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { AuthenticatorStep, type AuthenticatorType } from '../../types';

import './Sidenav.scss';

interface AuthStepProps {
    type: AuthenticatorType;
    step: AuthenticatorStep;
    onClick: (step: AuthenticatorStep) => void;
}

export const AuthSideNav = ({ step, onClick }: AuthStepProps) => {
    const { t } = useTranslation(['twoFactorAuth']);

    const checkValidStep = useCallback(
        (newStep: AuthenticatorStep) => {
            switch (step) {
                case AuthenticatorStep.BackupCodes:
                    if (newStep !== AuthenticatorStep.BackupCodes) {
                        return true;
                    }
                    break;
                case AuthenticatorStep.Confirmation:
                    if (newStep !== AuthenticatorStep.BackupCodes && newStep !== AuthenticatorStep.Confirmation) {
                        return true;
                    }
                    break;
                case AuthenticatorStep.SetupAuthenticatorEnterCode:
                    if (
                        newStep !== AuthenticatorStep.BackupCodes &&
                        newStep !== AuthenticatorStep.SetupAuthenticatorEnterCode
                    ) {
                        return true;
                    }
                    break;
                case AuthenticatorStep.SetupAuthenticator:
                    if (newStep === AuthenticatorStep.ChooseMethod) {
                        return true;
                    }
                    break;
                default:
                    return false;
            }
            return false;
        },
        [step],
    );

    const handleChangeStep = useCallback(
        (newStep: AuthenticatorStep) => {
            switch (step) {
                case AuthenticatorStep.BackupCodes:
                    if (newStep !== AuthenticatorStep.BackupCodes) {
                        onClick(newStep);
                    }
                    break;
                case AuthenticatorStep.Confirmation:
                    if (newStep !== AuthenticatorStep.BackupCodes && newStep !== AuthenticatorStep.Confirmation) {
                        onClick(newStep);
                    }
                    break;
                case AuthenticatorStep.SetupAuthenticatorEnterCode:
                    if (
                        newStep !== AuthenticatorStep.BackupCodes &&
                        newStep !== AuthenticatorStep.SetupAuthenticatorEnterCode
                    ) {
                        onClick(newStep);
                    }
                    break;
                case AuthenticatorStep.SetupAuthenticator:
                    if (newStep === AuthenticatorStep.ChooseMethod) {
                        onClick(newStep);
                    }
                    break;
                default:
                    break;
            }
        },
        [step, onClick],
    );

    return (
        <ul className="auth-step-sidenav">
            <li
                onClick={() => handleChangeStep(AuthenticatorStep.ChooseMethod)}
                className={`${step === AuthenticatorStep.ChooseMethod ? 'active' : ''} ${
                    checkValidStep(AuthenticatorStep.ChooseMethod) ? '' : 'disabled'
                }`}
            >
                {t('2fa_flow_sidenav_choose_method')}
            </li>
            <li
                onClick={() =>
                    handleChangeStep(
                        step === AuthenticatorStep.SetupAuthenticator
                            ? AuthenticatorStep.SetupAuthenticatorEnterCode
                            : AuthenticatorStep.SetupAuthenticator,
                    )
                }
                className={`${
                    step === AuthenticatorStep.SetupAuthenticator ||
                    step === AuthenticatorStep.SetupAuthenticatorEnterCode
                        ? 'active'
                        : ''
                } ${checkValidStep(AuthenticatorStep.SetupAuthenticator) ? '' : 'disabled'}`}
            >
                {t('2fa_flow_sidenav_setup_authenticator')}
            </li>
            <li
                onClick={() => handleChangeStep(AuthenticatorStep.Confirmation)}
                className={`${step === AuthenticatorStep.Confirmation ? 'active' : ''} ${
                    checkValidStep(AuthenticatorStep.Confirmation) ? '' : 'disabled'
                }`}
            >
                {t('2fa_flow_sidenav_confirmation')}
            </li>
        </ul>
    );
};
